class ProntoStorage {
	constructor(storeType) {
		this.storeType = storeType
		this.hasAccess = this.test()
		if (this.hasAccess) {
			this.store = window[storeType]
		}
	}
	get(key, defaultValue) {
		if (!this.hasAccess) return null
		const value = this.store.getItem(key)
		return value == undefined ? defaultValue : deserialize(value)
	}
	set(key, value) {
		if (!this.hasAccess) return null
		return this.store.setItem(key, serialize(value))
	}
	has(key) {
		return this.store.hasOwnProperty(key)
	}
	remove(key) {
		if (!this.hasAccess) return null
		return this.store.removeItem(key)
	}
	clear() {
		if (!this.hasAccess) return null
		return this.store.clear()
	}
	test() {
		return isStorageAvailable(this.storeType)
	}
}

export default ProntoStorage

const serialize = (value) => {
	return JSON.stringify(value)
}

const deserialize = (value) => {
	try {
		return JSON.parse(value)
	} catch (e) {
		return value
	}
}

export const isStorageAvailable = (storeType = 'localStorage') => {
	try {
		const test = 'test'
		window[storeType].setItem(test, test)
		window[storeType].removeItem(test)
		return true
	} catch (e) {
		console.error(`[STORAGE]: failed access test for ${storeType}`)
		return false
	}
}
